var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCareer2 = function SvgCareer2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.52 21.553h6.534a2.613 2.613 0 0 0 2.613-2.613V7.834a2.613 2.613 0 0 0-2.614-2.614H10.415a2.613 2.613 0 0 0-2.613 2.614v3.92m22.866 0H14.334m5.227 0v2.613M1.332 20.9h2.875v9.8H1.333M15.641 5.22h7.84l-.472-2.827a1.306 1.306 0 0 0-1.289-1.092H17.4a1.31 1.31 0 0 0-1.288 1.092zM4.208 29.59q.604.008 1.188.17l2.764.765c.41.114.832.171 1.256.171h3.728a4.526 4.526 0 0 0 4.555-4l.228-3.774a3.346 3.346 0 0 0-2.593-3.397l-1.11-.237a1.116 1.116 0 0 1-.866-1.076v-2.509a1.715 1.715 0 0 0-3.43 0v1.15a5.637 5.637 0 0 1-5.72 5.55z",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgCareer2;